import * as types from './types'

export const themes = {
    landing: {
        name: 'landing',
    },
    default: {
        name: 'default',
    },
    ingame: {
        name: 'ingame',
    },
    bonuses: {
        name: 'bonuses',
    }
};

export function setTheme(theme) {
    let selectedTheme = theme ? theme : 'default';
    return {
        type: types.SET_THEME,
        theme: themes[selectedTheme]
    }
}
